export enum ErrorMessages {
  NAME = 'Please enter name',
  NAME_REQUIRED = 'Please enter your first name',
  NAME_TEXT_ONLY= 'Name (only text is allowed)',
  NAME_LONG= 'A maximum of 30 characters is allowed for name',
  SURNAME= 'Please enter surname',
  SURNAME_REQUIRED = 'Please enter your surname',
  SURNAME_TEXT_ONLY= 'Surname (only text is allowed)',
  SURNAME_LONG= 'A maximum of 30 characters is allowed for surname',
  ID= 'Please enter ID number',
  ID_REQUIRED = 'Please enter your ID number',
  ID_INVALID= 'ID number is invalid',
  ID_SHORT= 'ID number provided is too short',
  ID_LONG= 'ID number provided is too long',
  PASSPORT_INVALID= 'Passport number is invalid',
  CELL= 'Please enter cellphone number',
  CELL_REQUIRED = 'Please enter your cellphone number',
  CELL_SHORT= 'The cellphone number provided is too short',
  CELL_LONG= 'The cellphone number provided is too long',
  CELL_INVALID= 'The cellphone number provided is invalid',
  CELL_NUMBER_ONLY= 'Cellphone number (only numeric value is allowed)',
  EMAIL = 'Please enter email address details',
  EMAIL_INVALID= 'The email provided is invalid',
  PLATE_OR_VIN= 'Please enter License plate or VIN number',
  NIGHT_PARKING =  'Please select night time parking suburb from the dropdown',
  VEHICLE_USAGE= 'Please select usage of vehicle',
  PARKING_SECURITY = 'Please select overnight parking security details',
  YEAR_ISSUE = 'Please provide the year your licence was first issued',
  VEHICLE_DESCRIPTION = 'Please select the make, model and year of your vehicle from the dropdown',
  VEHICLE_COLOUR = 'Please provide your vehicle\'s colour' ,
  LICENSE_TYPE = 'Please provide your licence type as shown on the back of your licence card.',
  YEAR_ISSUE_INVALID= 'Please provide a valid year of first issue',
  NUMBER_OF_CLAIMS = 'Please provide the number of vehicle claims, losses or incidents in the past 3 years',
  NUMBER_OF_CLAIMS_INVALID = 'Number of claims entered is invalid',
  RADIO_BUTTON_REQUIRED = 'Please select one of the options above',
  BANK_REQUIRED = 'Please select bank name'
}
